import { Api } from "../..";
import {
  API_GET_ADMIN_DECRYPTED_SECRET_KEY,
  API_GET_ADMIN_ENCRYPTED_SECRET_KEYS,
  API_PUT_ADMIN_DECRYPTED_SECRET_KEY,
} from "../../Apis/ApiEndPoints";
import {
  IGetAllSecretKeysResponse,
  IGetDecryptedSecretKeyResponse,
  IUpdateSecretKeyRequestBody,
  IUpdateSecretKeyResponse,
} from "../../models/admin/secretKeys/secretKeys";
import { CustomAction } from "./../../store/customAction";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getSecretKeys = createAsyncThunk(
  "secretsKeys/getSecretsKeys",
  async (_, { dispatch }) => {
    const response: IGetAllSecretKeysResponse = await CustomAction(
      Api.get(API_GET_ADMIN_ENCRYPTED_SECRET_KEYS),
      dispatch,
      "secretsKeys/getSecretsKeys"
    );
    return response;
  }
);
export const getDecryptedSecretKey = createAsyncThunk(
  "secretsKeys/getDecrpytedSecretKey",
  async (id: string, { dispatch }) => {
    const response: IGetDecryptedSecretKeyResponse = await CustomAction(
      Api.get(`${API_GET_ADMIN_DECRYPTED_SECRET_KEY}/${id}`),
      dispatch,
      "secretsKeys/getDecrpytedSecretKey"
    );
    return response;
  }
);
export const updateDecryptedSecretKey = createAsyncThunk(
  "secretsKeys/updateDecryptedSecretKey",
  async (
    {
      id,
      requestBody,
    }: { id: string; requestBody: IUpdateSecretKeyRequestBody },
    { dispatch }
  ) => {
    const response: IUpdateSecretKeyResponse = await CustomAction(
      Api.put(`${API_PUT_ADMIN_DECRYPTED_SECRET_KEY}/${id}`, requestBody),
      dispatch,
      "secretsKeys/updateDecryptedSecretKey"
    );
    return response;
  }
);
